export default "__VITE_ASSET__DcOlfIHh__"